import React from 'react'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton, LuxRichInputText } from '@lux/wardrobe-lib'
import { ProjectsService } from '@/app/services/ProjectsService'
import './DialogReject.scss'

const DialogReject = (props: {
    dialogVisible: boolean
    onChange: any
    onSave: () => void
    onHide: () => void
}) => {
    const { dialogVisible, onSave, onHide, onChange } = props

    const componentClass = 'smart-modals-dialog-reject'

    const intl = useIntl()

    const renderFooter = () => {
        return (
            <div className={`${componentClass}-buttons`}>
                <LuxButton
                    onClick={() => onSave()}
                    text={intl.formatMessage({
                        id: 'modals.dialog.redo_dialog.button.confirm',
                        defaultMessage: 'Confirm',
                    })}
                />
            </div>
        )
    }

    return (
        <Dialog
            header={intl.formatMessage({
                id: `modals.dialog.reject.title`,
                defaultMessage: 'Reject Reasons',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div>
                <div className={`${componentClass}-description`}>
                    {intl.formatMessage({
                        id: `modals.dialog.reject.description`,
                        defaultMessage: 'To continue add informations.',
                    })}
                </div>
                <LuxRichInputText
                    onChangeCallback={onChange}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.editing.reason.placeholder',
                        defaultMessage: 'Type here',
                    })}
                    fileUploadUrl={ProjectsService.FROALA_UPLOAD_URL}
                />
            </div>
        </Dialog>
    )
}

export default DialogReject
